export const errrorMessages = {
  0: "Sorry, this discount applies only to specific items. Click the button  to see which items are eligible.",
  1: "Sorry, this discount code is not applicable on selected items",
};

export const getDiscountedAmount = (discount, itemPrice) => {
  let discountedAmount = itemPrice;
  let discountValue = 0;
  if (discount?.discountType?.toLowerCase() === "percentage") {
    const percentage = Number(discount?.discountAmount) || 0;
    discountValue = (itemPrice * percentage) / 100;
    discountedAmount = itemPrice - discountValue;
  } else {
    discountedAmount = itemPrice - discount?.discountAmount;
  }
  return { discountedAmount, discountValue };
};
export const calculateItemDiscount = (discount, actualPrice) => {
  if (discount) {
    return getDiscountedAmount(discount, actualPrice);
  }
  return actualPrice;
};

export const getDiscount = ({ discounts, item, orderType, storeId }) => {

  if (!Array.isArray(discounts) || discounts.length === 0) return null;

  const allApplicableDiscounts = discounts.filter((discount) => {
    // 1️⃣ Must be active and not hidden
    if (!discount?.isActive) return false;
    if (discount?.discountApplication?.toLowerCase() === "hidden") return false;

    // 2️⃣ Check order type (support empty or missing serviceType)
    const matchesOrderType =
      !orderType ||
      !Array.isArray(discount?.serviceType) ||
      discount?.serviceType?.length === 0 ||
      discount?.serviceType?.some(
        (type) => type?.serviceName?.toLowerCase() === orderType?.toLowerCase()
      );

    if (!matchesOrderType) return false;

    // 3️⃣ Check item applicability
    const isApplicableToCurrentItem = discount?.discountAppliedOnSpecificItems?.some(
      (d) => d?.itemId === item?._id) || false
    
      const appliesToItem = isApplicableToCurrentItem /* ||  discount?.isApplicableOnAllItems */ 
    
    // const isApplicableToCurrentStore = storeId ? discount?.discountAppliedOnSpecificStores?.some(
    //   (d) => d?.storeId === storeId) : false;

    // const appliesToStore =   isApplicableToCurrentStore || discount?.isApplicableOnAllStores;

    // if(appliesToStore){
    //   if(appliesToItem){
    //     return true
    //   }
    //   return false
    // }
    // return appliesToItem || appliesToStore;

    return appliesToItem 
  });


  if (allApplicableDiscounts.length === 0) return null;

  let applicableDiscount = null;

  if (allApplicableDiscounts.length === 1)
    applicableDiscount = allApplicableDiscounts?.[0];
  else {
    const sortedDiscounts = allApplicableDiscounts.sort((a, b) => {
      // const aVal = calculateDiscountValue(a);
      // const bVal = calculateDiscountValue(b);

      // if (bVal !== aVal) return bVal - aVal;

      const aEnd = new Date(a?.endDate).getTime() || Infinity;
      const bEnd = new Date(b?.endDate).getTime() || Infinity;
      return aEnd - bEnd;
    });
    applicableDiscount = sortedDiscounts?.[0];
  }

  // 🔟 Return best applicable discount

  const isDiscountApplicableToCurrentItem =
    applicableDiscount?.discountAppliedOnSpecificItems?.some(
      (d) => d?.itemId === item?._id
    );

  applicableDiscount = {
    ...applicableDiscount,
    isDiscountApplicableToCurrentItem,
  };

  return applicableDiscount;
};

export const getFinalDiscountAmout = ({
  discounts,
  item,
  storeId,
  orderType,
}) => {
  const actualPrice = item?.price;
  const discount = getDiscount({ discounts, item, storeId, orderType });
  let discountedPrice = 0;
  if (!discount) return { actualPrice, discountedPrice };

  discountedPrice = calculateItemDiscount(discount, actualPrice) || 0;

  return {
    actualPrice,
    discountedPrice,
    ...{
      discountAmount: discount?.discountAmount,
      discountType: discount?.discountType,
    },
  };
};

export const getDiscountedPrice = ({
  itemPrice,
  quantity,
  applicableDiscount = {}
}) => {
  let discountInfoMessage = null;
  const actualPrice = itemPrice;
  const discount = calculateItemDiscount(applicableDiscount, itemPrice);
  let discountedPrice = discount?.discountedAmount;
  let isPerItemDiscount = false;

  if (
    actualPrice * quantity < applicableDiscount?.minOrderValue &&
    applicableDiscount?.isDiscountApplicableToCurrentItem
  ) {
    discountedPrice = 0;
    discountInfoMessage = { message:"you can apply it only if you order more than", 
      price: applicableDiscount?.minOrderValue,      
      discount:
        applicableDiscount?.discountAmount +
        (applicableDiscount?.discountType?.toLowerCase() === "percentage"
          ? ` % `
          : " AED"),
    };
  }
  
  else if (
    discount?.discountValue * quantity >
      applicableDiscount?.maximumDiscountValue &&
    applicableDiscount?.isDiscountApplicableToCurrentItem
  ) {
    discountedPrice =
      ((actualPrice * quantity) - applicableDiscount?.maximumDiscountValue) /
      quantity;
    isPerItemDiscount = true;
    discountInfoMessage = { message:"Maximum Discount for this item is", 
      price: applicableDiscount?.maximumDiscountValue,
      symbol: "AED",
    };
  }

  return {
    isDiscountApplicableToCurrentItem: applicableDiscount?.isDiscountApplicableToCurrentItem,
    minOrderValue: applicableDiscount?.minOrderValue,
    maximumDiscountValue: applicableDiscount?.maximumDiscountValue,
    discountAmount: applicableDiscount?.discountAmount,
    discountType: applicableDiscount?.discountType,
    discountedPrice: discountedPrice,
    actualPrice: itemPrice,
    discountInfoMessage: discountInfoMessage,
    discountValue: discount?.discountValue,
  };
};

export const getBasketValue = ({
  price = 0,
  quantity = 0,
  discountPrice = {},
}) => {
  let calculatedPrice = price * quantity;
  if (discountPrice?.discountedPrice) {
    calculatedPrice = discountPrice?.discountedPrice * quantity;
  }
  return calculatedPrice?.toFixed(2);
};
